module.exports = __webpack_public_path__ + "img/shape-cyan-big.7cb06c66.svg";